import { Box, Typography } from "@mui/material"
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useState } from "react";

interface FaqProps {
    titulo: string
    children: React.ReactNode
    IsOpen?: boolean
}

const Faq = (props: FaqProps) => {

    const [IsOpen, setIsOpen] = useState(props.IsOpen)

    const onClickAccordeon = () => {
        setIsOpen(!IsOpen)
    }

    return (
        <>
            <Box 
                paddingTop={2}
                paddingBottom={2}
                width={'100%'}
                display={"flex"}
                flexDirection={'column'}
                borderBottom={'1px solid #F1A648'}
                sx={{
                    cursor: 'pointer'
                }}
                onClick={onClickAccordeon}
            >
                <Box
                    display={"flex"}
                    justifyContent={'space-between'}
                >
                    <Typography fontWeight={700}>{props.titulo}</Typography>
                    {
                        IsOpen ?
                            <ArrowDropUpIcon style={{color:"#F1A648"}}/>
                        :
                            <ArrowDropDownIcon style={{color:"#F1A648"}}/>
                    }
                    
                </Box>
                {
                    IsOpen &&   
                    <Box
                        display={"flex"}
                        justifyContent={'space-between'}
                        marginTop={2}
                    >
                        <Typography fontSize={16} lineHeight={1.6}>{props.children}</Typography>
                    </Box>
                }

            </Box>
        </>       
    )
}


export default Faq
